import React from 'react';
import { AlertTriangleIcon, LockIcon, ZapIcon, TargetIcon, DropletIcon, FlameIcon, BatteryIcon, ChevronRightIcon, CameraIcon, StarIcon } from 'lucide-react';
export function RecommendationsPage() {
  return <div className="min-h-screen bg-[#0d0d0d] text-white font-sans selection:bg-[#b91c1c] selection:text-white" data-id="element-1484">
      {/* Top Nav Bar (matching other pages) */}
      <header className="bg-[#002868] text-white w-full" data-id="element-1485">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-12 flex items-center justify-between" data-id="element-1486">
          <div className="flex items-center gap-2 font-bold text-lg tracking-tight" data-id="element-1487">
            <StarIcon className="w-5 h-5 fill-current text-[#b91c1c]" data-id="element-1488" />
            <span data-id="element-1489">PatriotsInformer</span>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-8 px-4 text-center bg-[#0a0a0a] overflow-hidden" data-id="element-1490">
        {/* Subtle vertical stripes background effect */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(255,255,255,0.1) 40px, rgba(255,255,255,0.1) 80px)'
      }} data-id="element-1491"></div>

        <div className="relative z-10 max-w-3xl mx-auto space-y-6" data-id="element-1492">
          <p className="text-[#c5a059] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-1493">
            Patriots Informer · Trusted Resources
          </p>
          <h1 className="text-4xl md:text-7xl font-black tracking-tighter uppercase text-white leading-none" data-id="element-1494">
            Jack's Picks
          </h1>
          <p className="text-gray-400 text-lg md:text-xl italic font-serif max-w-2xl mx-auto leading-relaxed" data-id="element-1495">
            Every resource here has been hand-selected because it gives real,
            actionable knowledge, not theory. These are the tools I'd want my
            family to have before the lights go out.
          </p>
        </div>
      </section>

      {/* Red Banner */}
      <div className="bg-[#d92b2b] text-white py-3 px-4 text-center" data-id="element-1496">
        <p className="text-sm md:text-base font-bold tracking-wider uppercase flex items-center justify-center gap-2" data-id="element-1497">
          <AlertTriangleIcon className="w-4 h-4 flex-shrink-0" data-id="element-1498" />
          Real preparedness covers three things: Water, Food, and Energy. I've
          got you covered on all three.
        </p>
      </div>

      {/* Trust Badges */}

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-8 space-y-12" data-id="element-1499">
        {/* Section Header */}
        <div className="space-y-2" data-id="element-1500">
          <p className="text-[#c5a059] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-1501">
            My Recommendations
          </p>

          <div className="w-16 h-1 bg-[#c5a059]" data-id="element-1502"></div>
        </div>

        {/* Cards Container */}
        <div className="space-y-8" data-id="element-1503">
          {/* Card 1: Smart Water Box (Full Width) */}
          <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1504">
            {/* Left Border Accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c5a059]" data-id="element-1505"></div>

            {/* Title Area - Above Image */}
            <div className="p-6 md:p-8 pb-4 md:pb-4 relative" data-id="element-1506">
              {/* Badge */}
              <div className="absolute top-0 right-0 bg-[#d92b2b] text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1" data-id="element-1507">
                Editor's Pick
              </div>
              <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-1508">
                <DropletIcon className="w-3 h-3 fill-current text-[#3b82f6]" data-id="element-1509" />
                <span data-id="element-1510">Water Survival</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-black tracking-tight uppercase" data-id="element-1511">
                Smart Water Box
              </h3>
            </div>

            {/* Image + Content Row */}
            <div className="flex flex-col md:flex-row" data-id="element-1512">
              {/* Image Area */}
              <div className="w-full md:w-2/5 bg-[#111827] min-h-[250px] flex items-center justify-center border-y md:border-y-0 md:border-r border-[#333]" data-id="element-1513">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1514">
                  <CameraIcon className="w-6 h-6" data-id="element-1515" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1516">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-between relative" data-id="element-1517">
                <div className="space-y-4" data-id="element-1518">
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1519">
                    When the tap runs dry — whether from a grid failure, natural
                    disaster, or supply disruption — most families have no plan.
                    The Smart Water Box gives you a real one. A compact, proven
                    system to collect, filter, and store clean drinking water on
                    demand, anywhere.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1520">
                    <li className="flex items-start gap-2" data-id="element-1521">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1522">
                        ▶
                      </span>
                      <span data-id="element-1523">Works without running water or electricity</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1524">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1525">
                        ▶
                      </span>
                      <span data-id="element-1526">Enough clean water for a family of 4</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1527">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1528">
                        ▶
                      </span>
                      <span data-id="element-1529">Easy to build with common materials</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1530">
                  <div data-id="element-1531">
                    <div className="text-xl font-bold" data-id="element-1532">Watch Free Video</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1533">
                      Limited Availability
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1534">
                    Watch Now <ChevronRightIcon className="w-4 h-4" data-id="element-1535" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1536">
            {/* Card 2: The Lost Superfoods */}
            <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1537">
              {/* Top Border Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-[#c5a059]" data-id="element-1538"></div>

              {/* Image Area */}
              <div className="w-full bg-[#1c1a11] aspect-[4/3] flex items-center justify-center border-b border-[#333]" data-id="element-1539">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1540">
                  <CameraIcon className="w-6 h-6" data-id="element-1541" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1542">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 md:p-8 flex flex-col flex-1 justify-between" data-id="element-1543">
                <div className="space-y-4" data-id="element-1544">
                  <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1545">
                    <FlameIcon className="w-3 h-3 fill-current text-[#f97316]" data-id="element-1546" />
                    <span data-id="element-1547">Food Storage</span>
                  </div>

                  <h3 className="text-2xl font-black tracking-tight uppercase" data-id="element-1548">
                    The Lost Superfoods
                  </h3>

                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1549">
                    126 forgotten foods your grandparents knew how to preserve —
                    without refrigeration, without electricity, and for years at
                    a time. From the US Army's Cold War ration to Viking-era
                    preservation secrets, this is the food knowledge the modern
                    world buried.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1550">
                    <li className="flex items-start gap-2" data-id="element-1551">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1552">
                        ▶
                      </span>
                      <span data-id="element-1553">Store food for years without a fridge</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1554">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1555">
                        ▶
                      </span>
                      <span data-id="element-1556">Build a full stockpile for under $5/week</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1557">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1558">
                        ▶
                      </span>
                      <span data-id="element-1559">Color photos, step-by-step instructions</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1560">
                  <div data-id="element-1561">
                    <div className="text-xl font-bold" data-id="element-1562">$37</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1563">
                      Physical + Digital Book
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1564">
                    Get The Book <ChevronRightIcon className="w-4 h-4" data-id="element-1565" />
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3: Solar Innovator System */}
            <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1566">
              {/* Top Border Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-[#c5a059]" data-id="element-1567"></div>

              {/* Image Area */}
              <div className="w-full bg-[#1a1c11] aspect-[4/3] flex items-center justify-center border-b border-[#333]" data-id="element-1568">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1569">
                  <CameraIcon className="w-6 h-6" data-id="element-1570" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1571">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 md:p-8 flex flex-col flex-1 justify-between" data-id="element-1572">
                <div className="space-y-4" data-id="element-1573">
                  <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1574">
                    <ZapIcon className="w-3 h-3 fill-current text-[#eab308]" data-id="element-1575" />
                    <span data-id="element-1576">Energy Independence</span>
                  </div>

                  <h3 className="text-2xl font-black tracking-tight uppercase" data-id="element-1577">
                    Solar Innovator System
                  </h3>

                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1578">
                    A 3D solar sphere inspired by the compound eye of a housefly
                    — built in under 3 hours for around $200. It captures light
                    from nearly every angle, generating up to twice the power of
                    a flat panel in a fraction of the space. No roof required.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1579">
                    <li className="flex items-start gap-2" data-id="element-1580">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1581">
                        ▶
                      </span>
                      <span data-id="element-1582">Cut your electric bill by 50-80%</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1583">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1584">
                        ▶
                      </span>
                      <span data-id="element-1585">Works on a balcony or terrace — 12 sq ft</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1586">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1587">
                        ▶
                      </span>
                      <span data-id="element-1588">No technical skills required</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1589">
                  <div data-id="element-1590">
                    <div className="text-xl font-bold" data-id="element-1591">$39</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1592">
                      Instant Digital Access
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1593">
                    Watch Now <ChevronRightIcon className="w-4 h-4" data-id="element-1594" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Card 4: The Energy Revolution System (Full Width) */}
          <div className="bg-[#1a1a1a] border border-[#333] flex flex-col md:flex-row relative group" data-id="element-1595">
            {/* Left Border Accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c5a059]" data-id="element-1596"></div>

            {/* Image Area */}
            <div className="w-full md:w-2/5 bg-[#1a1811] min-h-[250px] flex items-center justify-center border-b md:border-b-0 md:border-r border-[#333]" data-id="element-1597">
              <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1598">
                <CameraIcon className="w-6 h-6" data-id="element-1599" />
                <span className="text-xs font-bold tracking-widest" data-id="element-1600">
                  IMAGE HERE
                </span>
              </div>
            </div>

            {/* Content Area */}
            <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-between relative" data-id="element-1601">
              {/* Badge */}
              <div className="absolute top-0 right-0 bg-[#333] text-gray-300 text-[10px] font-bold tracking-widest uppercase px-3 py-1" data-id="element-1602">
                Also Recommended
              </div>

              <div className="space-y-4" data-id="element-1603">
                <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1604">
                  <BatteryIcon className="w-3 h-3 fill-current text-[#c5a059]" data-id="element-1605" />
                  <span data-id="element-1606">Off-Grid Energy</span>
                </div>

                <h3 className="text-2xl md:text-3xl font-black tracking-tight uppercase" data-id="element-1607">
                  The Energy Revolution System
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1608">
                  A century-old device — suppressed for decades — that
                  multiplies any electricity source up to 7 times over. The
                  energy industry tried to bury it. Now it's out in the open,
                  and it could slash your bill by 88% within 30 days.
                </p>

                <ul className="space-y-2 text-sm text-gray-300" data-id="element-1609">
                  <li className="flex items-start gap-2" data-id="element-1610">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1611">▶</span>
                    <span data-id="element-1612">Based on 100-year-old suppressed technology</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1613">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1614">▶</span>
                    <span data-id="element-1615">Multiplies any power source up to 7x</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1616">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1617">▶</span>
                    <span data-id="element-1618">Runs indefinitely — no fuel, no intervention</span>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1619">
                <div data-id="element-1620">
                  <div className="text-xl font-bold" data-id="element-1621">Under $98</div>
                  <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1622">
                    One-Time Payment · 60-Day Guarantee
                  </div>
                </div>
                <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1623">
                  Watch The Leaked Video{' '}
                  <ChevronRightIcon className="w-4 h-4" data-id="element-1624" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#222] py-12 px-4 text-center text-xs text-gray-500 space-y-2" data-id="element-1625">
        <p data-id="element-1626">
          © 2026 Patriots Informer ·{' '}
          <a href="#" className="text-[#c5a059] hover:underline" data-id="element-1627">
            patriotsinformer.com
          </a>
        </p>
        <p className="max-w-2xl mx-auto" data-id="element-1628">
          This page contains affiliate links. If you purchase through these
          links, Patriots Informer may earn a commission at no extra cost to
          you. All products are independently selected and personally
          recommended.
        </p>
      </footer>
    </div>;
}